import PropTypes from 'prop-types'
import LinearProgress from '@material-ui/core/LinearProgress'
import gql from 'graphql-tag'
import { Query } from '@apollo/client/react/components'
import Error from '@components/error'
import { PromoBlockBySlugQuery } from '@components/content-promo-block/content-promo-block.query'
import ArchivePage from './archive-page'

const QUERY = gql`
  query BySlug($slug: String) {
    articlesBySlug(slug: $slug,) {
      headline
      category
      author
      hero_image
      hero_video
      body
      created_date
      slug
      url
      youtube_id
      nid
  }
}
`

const ArchivePageWithPromoBlock = (props) => {
  return (
    <Query query={PromoBlockBySlugQuery} variables={{ slug: 'archive' }}>
      {({
        loading, error, data,
      }) => {
        if (error) {
          return <Error error={error} displayErrorType="page" />
        }
        if (loading) return <LinearProgress color="secondary" />
        const promoBlock = data?.contentPromoBlockCollection?.items[0]
        return <ArchivePage {...props} promoBlock={promoBlock} />
      }}
    </Query>
  )
}

export default function ArchivePageWithData(props) {
  const { query } = props
  const {
    cat, subcat, subsubcat, slug, proxy,
  } = query

  let vars = {
    slug: [cat, subcat, subsubcat, slug].filter(s => s != null).join('/'),
  }

  if (proxy) { vars = { slug: decodeURI(proxy) } }

  return (
    <Query query={QUERY} variables={vars} context={{ clientName: 'pga-algolia' }}>
      {({
        loading, error, data,
      }) => {
        if (error) return <Error error={error} />
        if (loading) return <LinearProgress color="secondary" />

        const {
          articlesBySlug,
        } = data

        const article = articlesBySlug && articlesBySlug[0]
        const dataForError = {
          query,
          vars,
          article,
        }
        return article ? (
          <ArchivePageWithPromoBlock
            {...article}
            archive
          />
        ) : <Error statusCode={404} error={dataForError} />
      }}
    </Query>
  )
}

ArchivePageWithData.propTypes = {
  query: PropTypes.object,
}
